import axios from "axios";
import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
const About = () => {
  const [pageData, setPageData] = useState(null);
  const getPageData = () => {
    axios.get(API_URL.CMS.ABOUTUS).then(
      (res) => {
        if (res.data.code === 200) {
          setPageData(res.data.data);
        }
      },
      (error) => {}
    );
  };
  useEffect(() => {
    getPageData();
  }, []);
  return pageData ? (
    <section className="about-section pt-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-xl-7">
            <div className="main-title mb-3">
              <h2 className="mt0">About Us</h2>
            </div>
            <div
              className="about_content"
              dangerouslySetInnerHTML={{ __html: pageData.about_us }}
            ></div>
          </div>
          <div className="col-lg-4 col-xl-5">
            <div className="about_thumb">
              <img
                className="img-fluid w100"
                src={pageData.video_banner}
                alt="About Us"
              />
              <a
                className="popup-iframe popup-youtube color-white"
                href={pageData.video_link}
                target="_blank"
                rel="noreferrer"
              >
                <i className="flaticon-play"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null;
};

export default About;
